import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import WalletList from "./walletList";
import { CURRENCY_SYMBOL } from "../../../constant";
import { IoIosAdd } from "react-icons/io";
import MyBalance from "../../../pages/Profile/components/balance";
import { useNavigate, useLocation } from "react-router";
import {
  Box,
  Flex,
  Popover,
  PopoverTrigger,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import CreditPage from "../../../utils/credit/credit_page";

const isCredit = process.env.REACT_APP_CREDIT == 1;
const Balance = () => {
  const memberData = useSelector((state) => state.isMemberInfo);

  const { isOpen, onToggle, onClose } = useDisclosure();

  const baseBg = useColorModeValue("light.200", "dark.400");
  const baseHoverBg = useColorModeValue("light.300", "dark.500");

  const [openWallet, setOpenWallet] = useState(false);

  const { pathname } = useLocation();

  const navigate = useNavigate();

  return (
    <Popover
      variant={"brandPrimary"}
      isOpen={isOpen}
      onClose={onClose}
      placement="bottom"
    >
      <Flex
        borderRadius={`full`}
        bg={baseBg}
        _hover={{
          bg: baseHoverBg,
        }}
        pr={isCredit ? "15px" : "3px"}
        pl="15px"
        alignItems="center"
        gap="15px"
        height="38px"
        cursor="pointer"
        position="relative"
        mr={{
          sm: "10px",
        }}
      >
        <PopoverTrigger>
          <Box
            onClick={() => {
              if (pathname.includes("gamebox")) {
                return;
              } else {
                if (isCredit) {
                  return;
                }
                onToggle();
              }
            }}
            display={`flex`}
            alignItems={`center`}
            gap="5px"
          >
            <MyBalance className="dark:text-base-white text-base-dark !text-base" />
          </Box>
        </PopoverTrigger>
        <CreditPage>
          <Link to="profile/deposit">
            <Box
              w="33px"
              h="33px"
              bg="brand.500"
              borderRadius={`full`}
              color="white"
              display="flex"
              alignItems={`center`}
              justifyContent={`center`}
            >
              <IoIosAdd className="text-2xl " />
            </Box>
          </Link>
        </CreditPage>
      </Flex>
      <WalletList onClose={onClose} />
    </Popover>
  );
};

export default Balance;
